import { useEffect } from 'react';

// found this solution here:  https://web.dev/lazy-loading-video/
export const useVideoLazyLoad = () => {
  useEffect(() => {
    const handleDomLoadEvent = () => {
      if (document.readyState === 'complete') {
        const lazyVideos = document.querySelectorAll('video.lazy');

        const lazyVideoObserver = new IntersectionObserver((entries) => {
          const allVids: IntersectionObserverEntry[] = entries;
          for (const video of allVids) {
            if (video?.isIntersecting) {
              // @ts-ignore: this was erroring even though it is a source element so disabling
              const videoSource: HTMLSourceElement = video.target.children?.[0];
              // @ts-ignore: this was erroring even though it is a video element so disabling
              const videoTarget: HTMLVideoElement = video.target;
              if (typeof videoSource.tagName === 'string' && videoSource.tagName === 'SOURCE') {
                videoSource.src = videoSource.dataset.src;
              }
              videoTarget.load();
              videoTarget.classList.remove('lazy');
              lazyVideoObserver.unobserve(videoTarget);
            }
          }
        });
        for (const lazyVideo of lazyVideos) {
          lazyVideoObserver.observe(lazyVideo);
        }
      }
    };

    document.addEventListener('readystatechange', handleDomLoadEvent);
    document.addEventListener('scroll', handleDomLoadEvent);

    return () => {
      document.removeEventListener('readystatechange', handleDomLoadEvent);
      document.removeEventListener('scroll', handleDomLoadEvent);
    };
  });
};
